/**
 * Defer execution of a method until the next micro-task.
 *
 * @param method - the method to defer
 */
export const defer = (method: () => void): void => {

    void Promise.resolve().then(() => method());
};
